/**
 * Concat any variable length argument which is type of string.
 * @param  {...any} strings
 * @returns {string}
 */
export const concatStrings = (...strings) => {
  return strings.reduce((acc, curr) => {
    if (!curr) return acc
    return acc ? `${acc} ${curr}` : curr
  })
}
export const makeCapitalCase = (data) => {
  if (data) {
    data = data.toLowerCase()
    return data.charAt(0).toUpperCase() + data.slice(1)
  }
  return '--'
}
